import { useTranslation } from "react-i18next"

export function SocialProofBar() {
    const { t } = useTranslation('landing')

    return (
        <section className="border-y bg-muted/50 py-8 overflow-hidden bg-gradient-to-r from-pink-500/5 via-purple-500/5 to-emerald-500/5">
            <div className="container mx-auto px-4 text-center">
                <p className="text-sm text-muted-foreground">
                    <span className="bg-gradient-to-r from-emerald-600 via-purple-600 to-pink-600 bg-clip-text text-transparent font-medium dark:from-emerald-400 dark:via-purple-400 dark:to-pink-400">
                        {t('socialProof.highlight')}
                    </span>{" "}
                    {t('socialProof.text')}
                </p>

                {/* Subtle animated dots */}
                <div className="flex items-center justify-center gap-2 mt-4">
                    <div className="w-2 h-2 rounded-full bg-emerald-500/60 animate-pulse" />
                    <div className="w-2 h-2 rounded-full bg-purple-500/60 animate-pulse" />
                    <div className="w-2 h-2 rounded-full bg-pink-500/60 animate-pulse" />
                </div>
            </div>
        </section>
    )
}
